module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Rubik/Rubik-Italic-dd425b2765df0b8534886a866b864377.ttf";